import React from 'react';

interface PasswordStrengthProps {
  password: string;
}

const getStrength = (pw: string): { level: number; label: string; color: string } => {
  if (!pw) return { level: 0, label: '', color: 'transparent' };

  let score = 0;
  if (pw.length >= 6) score++;
  if (pw.length >= 10) score++;
  if (/[A-Z]/.test(pw) && /[a-z]/.test(pw)) score++;
  if (/\d/.test(pw)) score++;
  if (/[^A-Za-z0-9]/.test(pw)) score++;

  if (score <= 1) return { level: 20, label: 'Weak', color: 'var(--badge-red-text)' };
  if (score === 2) return { level: 40, label: 'Fair', color: 'var(--badge-amber-text)' };
  if (score === 3) return { level: 60, label: 'Good', color: 'var(--accent-warm)' };
  if (score === 4) return { level: 80, label: 'Strong', color: 'var(--badge-green-text)' };
  return { level: 100, label: 'Very strong', color: 'var(--badge-green-text)' };
};

const PasswordStrength: React.FC<PasswordStrengthProps> = ({ password }) => {
  const { level, label, color } = getStrength(password);

  if (!password) return null;

  return (
    <div className="mt-1.5">
      <div className="strength-meter">
        <div
          className="strength-meter-fill"
          style={{ width: `${level}%`, backgroundColor: color }}
        />
      </div>
      <p className="text-xs mt-1 font-medium" style={{ color }}>{label}</p>
    </div>
  );
};

export default PasswordStrength;
